import StoreHelper from '../../store/helper'

import { IRegistrableInstance } from './Registrable'
import { onDragover, onDragleave, onDrop } from './handlers'

class Droppable extends IRegistrableInstance {
  constructor (el) {
    super()
    this.el = el

    this.onDragover = onDragover
    this.onDragleave = onDragleave
    this.onDrop = onDrop
  }

  registered () {
    StoreHelper.registerDropTarget(this.el)

    this.el.addEventListener('dragover', this.onDragover)
    this.el.addEventListener('dragleave', this.onDragleave)
    this.el.addEventListener('drop', this.onDrop)
  }

  unregistered () {
    StoreHelper.unregisterDropTarget(this.el)

    this.el.removeEventListener('dragover', this.onDragover)
    this.el.removeEventListener('dragleave', this.onDragleave)
    this.el.removeEventListener('drop', this.onDrop)
  }
}

export default Droppable
